import React, { useRef, useState } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import { useTranslation } from '~/dependencies';
import {
  MessagesIcon,
  SMSIcon,
  TeamsIcon,
  WhatsappIcon,
  ArrowUpIcon,
} from '~/assets/svgIcons';
import { colors } from '~/layout';
import { ChannelTypeEnum } from '~/enums/conversations';
import {
  ArrowIcon,
  Button,
  Container,
  Icon,
  Menu,
  MenuItem,
  MenuList,
} from './styles';

type ChannelType = {
  id: number;
  type: ChannelTypeEnum | number;
  name: string;
  icon: string;
  iconColor?: string;
  enabled: boolean;
};

type ChannelMenuProps = {
  onChange: (channelId: ChannelTypeEnum) => void;
  disabled?: boolean;
};

export default function ChannelMenu({ onChange, disabled }: ChannelMenuProps) {
  const { t } = useTranslation();
  const menuRef = useRef(null);

  const channelOptions: ChannelType[] = [
    {
      id: 1,
      name: t('screens.conversation.allChats'),
      type: 0,
      icon: MessagesIcon,
      iconColor: colors.darkGray11,
      enabled: true,
    },
    {
      id: 2,
      name: 'SMS Chats',
      type: ChannelTypeEnum.SMS,
      icon: SMSIcon,
      enabled: true,
    },
    {
      id: 3,
      name: 'WhatsApp',
      type: ChannelTypeEnum.WHATSAPP,
      icon: WhatsappIcon,
      enabled: true,
    },
    {
      id: 4,
      name: 'Internal',
      type: ChannelTypeEnum.INTERNAL,
      icon: TeamsIcon,
      enabled: true,
    },
  ];

  // STATES
  const [open, setOpen] = useState<boolean>(false);
  const [currSelected, setCurrSelected] = useState<ChannelType>(
    channelOptions[0]
  );

  const handleSelection = (channel: ChannelType) => {
    setOpen(false);
    setCurrSelected(channel);

    if (onChange) {
      onChange(channel.type);
    }
  };

  const handleOpen = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Container>
        <Menu ref={menuRef}>
          <Button onClick={handleOpen} open={open}>
            <Icon src={currSelected.icon} color={currSelected.iconColor} />
            <span style={{ fontWeight: 'bold', color: colors.darkGray11 }}>
              {currSelected.name}
            </span>
            <ArrowIcon open={open} src={ArrowUpIcon} />
          </Button>

          <MenuList open={open}>
            {channelOptions
              .filter(e => e.enabled)
              .map(e => (
                <li key={String(e.id)}>
                  <MenuItem role="button" onClick={() => handleSelection(e)}>
                    <Icon src={e.icon} color={e.iconColor} />
                    <span
                      style={{
                        fontWeight:
                          currSelected.id === e.id ? 'bold' : 'normal',
                        color: colors.darkGray11,
                      }}>
                      {e.name}
                    </span>
                  </MenuItem>
                </li>
              ))}
          </MenuList>
        </Menu>
      </Container>
    </ClickAwayListener>
  );
}

ChannelMenu.defaultProps = {
  disabled: false,
};
